import React, { useState, useEffect, useContext } from "react";
import * as S from "./styles";

import PessoaJuridica from "../../assets/navbar/Pessoa_juridica_on.svg";
import Agentes from "../../assets/navbar/Agentes_on.svg";

import Button from "../../components/Button";

import api from "../../services/api";

import TablePagination from "@mui/material/TablePagination";
import { makeStyles } from "@mui/styles";

import { toast } from "react-toastify";

import { Context } from "../../context/globalContext";
import { mask } from "../../utils/mask";
import desmaskIfNumber from "../../utils/desmaskIfNumber";
import SkeletonListItem from "../SkeletonListItem";
import InputText from "../InputText";
import { useParams } from "react-router";

const useStyles = makeStyles({
  caption: {
    padding: 8,
    fontSize: "1.25rem",
  },
  toolbar: {
    "& > p:nth-of-type(2)": {
      fontSize: "1.25rem",
      color: "red",
      fontWeight: 600,
    },
  },
});

export default function ListHistoryAgentStore({
  history,
  pageFilter,
  filter,
  state,
  stateName,
  type,
}) {
  const { setIsLoading, isLoading } = useContext(Context);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const { pageLimit, setPageLimit } = useContext(Context);
  const { id } = useParams();

  const [agents, setAgents] = useState([]);
  const [search, setSearch] = useState("");
  const [searchType, setSearchType] = useState("AGENTE");
  const [currentAgent, setCurrentAgent] = useState(false);

  async function getDataByAgentCnpj(cpfCnpj, entidadePai, type, page) {
    try {
      setIsLoading(true);
      const response = await api.get(
        `/api/historico/buscar?filter=${cpfCnpj}&entidadePaiId=${entidadePai}&tipoHistorico=AGENTE&page=${
          page || 0
        }&size=${pageLimit}`
      );
      if (response && (response.status === 201 || response.status === 200)) {
        setAgents(response.data.content);
        setPage(page || 0);
        setTotalPages(response.data.totalPages);
        setTotalElements(response.data.totalElements);
      } else if (!response) {
        setPage(page || 0);
        setAgents([]);
        setTotalPages(0);
        setTotalElements(0);
        toast.error("Erro ao buscar os agentes.");
      }

      setIsLoading(false);
    } catch (err) {
      setPage(page || 0);
      setTotalPages(0);
      setTotalElements(0);
      setAgents([]);
      setIsLoading(false);
      err?.response?.status === 500 &&
        toast.error("Erro de servidor, entre em contato com o administrador!");
      err?.response?.status === 400 &&
        toast.error("Erro ao buscar os agentes.");
    }
  }

  useEffect(() => {
    if (filter) {
      setSearch(filter);
    }
    if (type) {
      setSearchType(type);
    }

    if (pageFilter) {
      setPage(pageFilter);
    }

    loadAgent(filter, id, type, pageFilter);
  }, [filter, id, type, pageFilter]);

  async function loadAgent(filter, id, type, page) {
    getDataByAgentCnpj(filter, id, type, page);
  }

  const reloadPage = (filter, page) => {
    history.replace(
      `?filter=${desmaskIfNumber(filter.search)}${
        page && page > 0 ? "&page=" + page : ""
      }`
    );
  };

  const handleKeyPress = (event) => {
    const value = event.target.value;
    if (event.key === "Enter") {
      reloadPage(value);
    }
  };

  function timeStampToDate(timestamp) {
    if (timestamp === null) {
      //setCurrentAgent(true);
      return <span className="current-agent">Em andamento</span>;
    } else {
      //setCurrentAgent(false)
      const date = new Date(timestamp);
      return date.toLocaleDateString("pt-BR");
    }
  }
  return (
    <>
      <S.Container>
        <S.Card>
          <S.SearchWrapper>
            <div className="labelFilter">Filtrar pesquisa</div>
            <div className="boxSearch">
              <div className="wrapperInputButton">
                <div className="inputContainer">
                  <span className="inputWrapper">
                    <InputText
                      type="text"
                      name="search"
                      label="CPF, CNPJ ou Nome:"
                      alwaysShowMask={false}
                      autoComplete={"off"}
                      value={search}
                      onKeyPress={(e) => handleKeyPress(e)}
                      onChange={(ev) => setSearch(ev.target.value)}
                    />
                  </span>
                </div>
                <Button
                  type="button"
                  onClick={() =>
                    reloadPage({
                      search,
                      searchType,
                    })
                  }
                >
                  consultar
                </Button>
              </div>
            </div>
          </S.SearchWrapper>
          <S.CardHeader>
            <span>
              {`${totalElements} agente${
                totalElements > 1 ? "s" : ""
              } cadastrado${totalElements > 1 ? "s" : ""} no sistema`}
            </span>
            {totalElements > 0 && (
              <span className="border">
                Selecione o icone para acessar o cadastro
              </span>
            )}
          </S.CardHeader>

          {!isLoading ? (
            <S.CardBody>
              {agents &&
                agents?.map((user) => {
                  return (
                    <>
                      <S.Custumer>
                        <S.Info
                          onClick={() =>
                            history?.push(
                              `/cadastro-agentes/${user?.entidade?.id}`
                            )
                          }
                        >
                          <S.SvgIcon src={Agentes} alt="" />
                          <div className="dataCard">
                            <h4>CNPJ:</h4>
                            <h4>Nome:</h4>
                            <h4>Início da vigência: </h4>
                          </div>
                          <div className="dataCard">
                            <h4 className="h4-info">
                              {mask(
                                user?.entidade?.cpfCnpj,
                                user?.entidade?.cpfCnpj > 11
                                  ? "##.###.###/####-##"
                                  : "###.###.###-##",
                                true
                              )}
                            </h4>
                            <h4 className="h4-info">{user?.descricao}</h4>
                            <span className="span-info">
                              <h4 className="h4-info">
                                {timeStampToDate(user?.inicioVigencia)}
                              </h4>
                              {user?.fimVigencia !== null && (
                                <h4>Fim da vigência:</h4>
                              )}
                              <h4
                                className={
                                  currentAgent ? "current-agent" : "h4-info"
                                }
                              >
                                {timeStampToDate(user?.fimVigencia)}
                              </h4>
                            </span>
                          </div>
                        </S.Info>

                        <div className="iconService">
                          <S.SvgIcon
                            onClick={() => {
                              if (
                                !user?.entidade ||
                                user?.entidade?.id === null
                              ) {
                                toast.error(
                                  "Este agente não possui uma pessoa jurídica vinculada!"
                                );
                                return;
                              }

                              history.push(
                                `${
                                  user?.entidade?.cpfCnpj > 11
                                    ? `/cadastro-pessoa-juridica/${user?.entidade?.id}`
                                    : `/cadastro-pessoa-fisica/${user?.entidade?.id}`
                                }`
                              );
                            }}
                            src={PessoaJuridica}
                            alt=""
                          />
                        </div>
                      </S.Custumer>
                    </>
                  );
                })}

              {totalPages > 1 && (
                <TablePagination
                  component="div"
                  classes={{
                    toolbar: classes.toolbar,
                    caption: classes.caption,
                  }}
                  count={totalElements}
                  page={page}
                  labelDisplayedRows={({ from, to, count }) => {
                    return from + " - " + to + " de " + count;
                  }}
                  onPageChange={(p, newPage) =>
                    reloadPage({ search, searchType }, newPage)
                  }
                  rowsPerPageOptions={[]}
                  rowsPerPage={pageLimit}
                />
              )}
            </S.CardBody>
          ) : (
            <SkeletonListItem />
          )}
        </S.Card>
      </S.Container>
    </>
  );
}
